export default __webpack_public_path__ + "static/masthead_bg_desktop_france-51822097f91f8b7796a4988748891026.jpg";